<!-- =========================================================================================
  File Name: SponsorEdit.vue
  Description: Sponsor Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style lang="scss">
.header-custome{margin-bottom: 15px; padding-left: 2px;}
.action-butn-resize-wrap{display: flex; justify-content: flex-start; align-items: center; flex-wrap: wrap;}
</style>
<template>
  <div id="page-user-edit">
    <div class="content">
      <section class="cropper-area">
        <div class="img-cropper">
          <vue-cropper
            ref="cropper"
           :aspect-ratio="aspectValue"
            :src="sourceImage"
            preview=".preview"
          />
        </div> 
      </section>
      <section class="preview-area">
        <p class="mt-0">Preview</p>
        <div id="image" class="preview" />
      </section>
    </div>

      <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="upload_photo">Upload</vs-button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
//import { bus } from "../../main";

export default {
  components: {
    VueCropper
  },
    props: {
    aspectValue: {
      type: Number,
      required: true
    },
     sourceImage: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      photowall_data: null,
      photowall_not_found: false,
      imgSrc: "https://firebasestorage.googleapis.com/v0/b/uate2monair.appspot.com/o/OA_UAT_C1591904892446E1598284508652%2FPhotoWall%2FGeneral%2F1621962369375_405435%20-%20Copy.jpg?alt=media",
      cropImg: '',
      data: null,


      /*
        This property is created for fetching latest data from API when tab is changed

        Please check it's watcher
      */
      activeTab: 0
    };
  },
  watch: {
    
  },
  methods: {
    upload_photo(){
      let cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL()
      let json = JSON.stringify(cropImg, null, 2);
      let blob = new Blob([json], { type: "image/png" });


       //console.log("data_url======",cropImg.toString());
         //console.log("blob======",blob);
       this.$emit("croppedImagePath", cropImg.toString());
    },
    


        // bus.$on("croppedImagePath", (data) => {
        //   alert(data)
        //   // this.imgSrc = data;
        //   reader.onload = (e) => {
        //   // this.resetCropper += 1;
        //   // this.cropImageUrl = null;
        //   // this.cropImageUrl = e.target.result;
        //   // this.popupCropper = true;
        //   this.imgSrc = null;
        //   this.imgSrc = e.target.result;
        // };
        //    reader.readAsBinaryString(data);
        //   this.popupCropper = false;
        // });
    
  },
  created() {
    if(this.$route.params.row)
    {
      this.photowall_data = this.$route.params.row
      this.imgSrc = this.$route.params.row.photoUrl
    }
    else
      this.photowall_not_found = true

  },
};
</script>

<style>

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0 5px 0;
}
.header h2 {
  margin: 0;
}
.header a {
  text-decoration: none;
  color: black;
}
.content {
  display: flex;
  justify-content: space-between;
}
.cropper-area {
    width: 614px;
    border: 1px solid #cbcbcb;
    margin-top: 50px;
}
.actions {
  margin-top: 1rem;
}
.actions a {
  display: inline-block;
  padding: 5px 15px;
  background: #0062CC;
  color: white;
  text-decoration: none;
  border-radius: 3px;
  margin-right: 1rem;
  margin-bottom: 1rem;
}
textarea {
  width: 100%;
  height: 100px;
}
.preview-area {
    width: 400px;
    margin-top: 41px;
    position: relative;
}
.preview-area:after {
    content: "";
    position: absolute;
    height: 100%;
    width: 1px;
    background: #cbcbcb;
    right: 100%;
    top: 0;
    margin-right: 21px;
}
.preview-area p {
  font-size: 1.25rem;
  margin: 0;
  margin-bottom: 1rem;
}
.preview-area p:last-of-type {
  margin-top: 1rem;
}
.preview {
  width: 100%;
  height: calc(372px * (9 / 16));
  overflow: hidden;
}
.crop-placeholder {
  width: 100%;
  height: 200px;
  background: #ccc;
}
.cropped-image img {
  max-width: 100%;
}
</style>